import { render, staticRenderFns } from "./VideoStream.vue?vue&type=template&id=2671648e&scoped=true"
import script from "./VideoStream.vue?vue&type=script&lang=js"
export * from "./VideoStream.vue?vue&type=script&lang=js"
import style0 from "./VideoStream.vue?vue&type=style&index=0&id=2671648e&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2671648e",
  null
  
)

export default component.exports